import cx from 'classnames'
import styles from './Guide.module.scss'

const Guide = ({ children = null }) => {
    return <div className={styles.guide}>{children}</div>
}

export default Guide
